<div class="u-flex-row u-margin-bottom">
    <div class="u-w40p u-color-muted u-font-weight-semi-bold u-padding-right">
        {{ label }}
    </div>
    <div class="__info-detail__content u-w60p">
        <ng-content></ng-content>
    </div>
</div>
